import type { ProductCategory } from '../../../../shared/types/partnerships';

const CATEGORY_STYLE: Record<ProductCategory, string> = {
  Motors:        'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  Experience:    'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
  Amplification: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300',
  Enhancers:     'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  Phygital:      'bg-pink-100 text-pink-700 dark:bg-pink-900/30 dark:text-pink-300',
};

export function CategoryBadge({ category }: { category: ProductCategory }) {
  return (
    <span className={`inline-flex items-center text-xs font-medium px-2 py-0.5 rounded-full ${CATEGORY_STYLE[category]}`}>
      {category}
    </span>
  );
}
